<template>
  <Base
    :detail="detail"
    v-if="defaultPrize && defaultPrize.length > 0"
    :show-loading="showLoading"
  >
    <div class="luckdraw-warp" :style="'width:' + 600 * baseSize + 'px;'">
      <div
        class="luckdraw-scene"
        :class="paused ? 'paused' : ''"
        :style="
          'width:' + 600 * baseSize + 'px;height:' + 600 * baseSize + 'px;'
        "
      >
        <div
          class="luckdraw-egg"
          @click="crackEgg(0)"
          :class="activeIndex === 0 ? 'active' : ''"
          :style="
            'z-index:' +
              pos[3] +
              ';transform:translate3d(' +
              pos[0] +
              'px,' +
              pos[1] +
              'px,' +
              pos[2] +
              'px);'
          "
        >
          <img
            :src="activeIndex === 0 ? images[1] : images[0]"
            class="egg-image"
          />
          <img :src="images[2]" class="egg-hammer" v-show="activeIndex === 0" />
        </div>
        <div
          class="luckdraw-egg"
          :class="activeIndex === 1 ? 'active' : ''"
          @click="crackEgg(1)"
          :style="
            'z-index:' +
              pos1[3] +
              ';transform:translate3d(' +
              pos1[0] +
              'px,' +
              pos1[1] +
              'px,' +
              pos1[2] +
              'px);'
          "
        >
          <img
            :src="activeIndex === 1 ? images[1] : images[0]"
            class="egg-image"
          />
          <img :src="images[2]" class="egg-hammer" v-show="activeIndex === 1" />
        </div>
        <div
          class="luckdraw-egg"
          @click="crackEgg(2)"
          :class="activeIndex === 2 ? 'active' : ''"
          :style="
            'z-index:' +
              pos2[3] +
              ';transform:translate3d(' +
              pos2[0] +
              'px,' +
              pos2[1] +
              'px,' +
              pos2[2] +
              'px);'
          "
        >
          <img
            :src="activeIndex === 2 ? images[1] : images[0]"
            class="egg-image"
          />
          <img :src="images[2]" class="egg-hammer" v-show="activeIndex === 2" />
        </div>
      </div>
    </div>
    <div
      class="active-num"
      :style="
        'margin-top:' +
          56 * baseSize +
          'px;margin-bottom:' +
          56 * baseSize +
          'px;width:' +
          692 * baseSize +
          'px'
      "
    >
      <div
        class="active-num-text"
        :style="
          'bottom:' + 60 * baseSize + 'px; font-size:' + 24 * baseSize + 'px'
        "
      >
        You've got <span class="underline yellow">{{ chance }}</span
        > times<br>left to draw for today.
        <!-- 已有<span>{{ detail.join_num }}</span
        >人参与<br />
        您今天还有<span class="underline yellow">{{ chance }}</span
        >次抽奖机会 -->
      </div>
    </div>
    <PrizeDetail :detail="detail" :myAwards="myAwards" />
  </Base>
</template>

<script>
import { LuckDrawMixin } from "@/mixins/Luckdraw";
import eggImage from "@/assets/img/award/egg.png";
import eggImage2 from "@/assets/img/award/egg2.png";
import hammerImage from "@/assets/img/award/hammer.png";

export default {
  mixins: [LuckDrawMixin],
  data() {
    return {
      images: [eggImage, eggImage2, hammerImage],
      defaultPrize: [],
      paused: true,
      tid: null,
      degree: 180,
      activeIndex: -1,
      pos: [0, 0, 0, 0],
      pos1: [0, 0, 0, 0],
      pos2: [0, 0, 0, 0]
    };
  },
  methods: {
    crackEgg(index) {
      if(!this.checkLogin()) return ;
      const endTime = this.detail.end_time
        ? new Date(this.detail.end_time.replace(/-/g, "/")).getTime()
        : "";
      const nowTime = new Date().getTime();
      if (!endTime || endTime < nowTime) {
        this.showMessage("Game over!");
        this.stop();
        return;
      }
      if (this.chance < 1) {
        this.showMessage("No chance today, come back tomorrow.!");
        this.stop();
        return;
      }
      if (this.activeIndex > -1) return;
      this.activeIndex = index;
      this.stop();
      this.showLoading = true;
      this.getResult();
    },
    stop() {
      clearInterval(this.tid);
      this.paused = true;
    },
    init() {
      //ox,oy表示圆心坐标
      let ox = 300 * this.baseSize;
      let oy = 300 * this.baseSize;
      let radius = 150 * this.baseSize;
      this.paused = false;
      this.activeIndex = -1;
      this.degree = 60;
      this.tid = setInterval(() => {
        const degree = this.degree;
        this.degree += 1;
        this.degree %= 360;
        let rad = (Math.PI / 180) * degree;
        let rad1 = (Math.PI / 180) * (degree + 120);
        let rad2 = (Math.PI / 180) * (degree - 120);
        let x = Math.sin(rad) * radius;
        let y = Math.cos(rad) * radius;
        let x1 = Math.sin(rad1) * radius;
        let y1 = Math.cos(rad1) * radius;
        let x2 = Math.sin(rad2) * radius;
        let y2 = Math.cos(rad2) * radius;
        let i, i1, i2;
        if (degree <= 70 || degree > 310) {
          i = 3;
          i1 = 1;
          i2 = 2;
        } else if (degree > 70 && degree <= 190) {
          i = 1;
          i1 = 2;
          i2 = 3;
        } else {
          i = 2;
          i1 = 3;
          i2 = 1;
        }
        this.pos = [ox + x, oy + y, y, i];
        this.pos1 = [ox + x1, oy + y1, y1, i1];
        this.pos2 = [ox + x2, oy + y2, y2, i2];
      }, 30);
    },

    handleData(data) {
      let temp = { ...data };
      if (!temp.background_img)
        temp.background_img = require("@/assets/img/award/beij.jpg");
      if (!temp.brief_img)
        temp.brief_img = require("@/assets/img/award/title.png");
      this.detail = { ...temp };
      this.myAwards = [...this.detail.my_awards];
      this.chance = this.detail.remaining_num || 0;
      this.defaultPrize = [...data.prizes];
      this.init();
    },
    handleResult(data) {
      this.chance -= 1;
      const { id, title, level, image } = data.award;
      if(id) this.myAwards.unshift({ id, title, level, image });
      this.showLoading = false;
      if (id === 0) {
        this.showResult({ type: 1 });
      } else {
        this.showResult({ type: 3, title, level });
      }
    }
  }
};
</script>

<style scoped lang="scss">
img {
  display: block;
  max-width: 100%;
}

.underline {
  text-decoration: underline;
}
.d-warp {
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  .main {
    width: 100%;
    min-height: 100vh;
    .luckdraw-warp,
    .title-warp {
      margin: 0 auto;
    }
    .luckdraw-warp {
      position: relative;
      z-index: 2;
      perspective: 500;
      -webkit-perspective: 500;
      perspective-origin: center bottom;
      -webkit-perspective-origin: center bottom;
      .luckdraw-egg {
        position: absolute;
        left: 0;
        right: 0;
        margin-left: -6.5rem;
        margin-top: -6.5rem;
        width: 13rem;
        height: 13rem;
        border-radius: 8rem;
        &.active {
          z-index: 99;
        }
        .egg-image {
        }
        .egg-hammer {
          position: absolute;
          top: 0;
          left: 50%;
          margin-left: -1rem;
          margin-top: -2rem;
          width: 6rem;
          animation: crack 0.5s linear;
          animation-fill-mode: forwards;
        }
      }
      .paused {
        .luckdraw-egg {
          animation-play-state: paused;
          -webkit-animation: none;
          // .egg-hammer {
          //   animation-play-state: paused;
          // }
        }
      }
    }
    .active-num {
      position: relative;
      z-index: 1;
      margin-left: auto;
      margin-right: auto;
      img {
        padding-left: 1%;
      }
    }
    .active-num-text {
      font-size: 12px;
      text-align: center;
      color: #fff;
      line-height: 1.4;
      span {
        display: inline-block;
        margin: 0 2px;
      }
    }
  }
}
@keyframes crack {
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(15deg);
  }
  50% {
    transform: rotate(-45deg);
  }
  100% {
    transform: rotate(-15deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/LuckyEgg.vue